module.exports = __webpack_public_path__ + "img/icone-adicionar.b3fccfef.svg";